<template>
  <div class="main">
    <p class="debaoImgBox">
      <img src="../assets/img/debao.png" alt="logo" class="debaoImg">
    </p>
    <!--    <div class="contentArea">-->
    <!--            <div class="slogan">-->
    <!--              <p>登录</p>-->
    <!--              &lt;!&ndash; <p><span class="blue">德迅智能客服系统</span></p> &ndash;&gt;-->
    <!--            </div>-->
    <!--                  <van-form @submit="login">-->
    <!--                    <van-cell-group inset>-->
    <!--                      <van-field-->
    <!--                        left-icon="manager"-->
    <!--                        v-model="loginData.companyAccount"-->
    <!--                        name="企业账号"-->
    <!--                        label=""-->
    <!--                        placeholder="企业账号"-->
    <!--                        :rules="[{ required: true, message: '请填写企业账号' }]"-->
    <!--                      />-->
    <!--                      <van-field-->
    <!--                        left-icon="manager"-->
    <!--                        v-model="loginData.companySecretKey"-->
    <!--                        name="企业秘钥"-->
    <!--                        label=""-->
    <!--                        placeholder="企业秘钥"-->
    <!--                        :rules="[{ required: true, message: '请填写企业秘钥' }]"-->
    <!--                      />-->
    <!--                      <van-field-->
    <!--                        left-icon="manager"-->
    <!--                        v-model="loginData.uniqueCode"-->
    <!--                        name="用户名"-->
    <!--                        label=""-->
    <!--                        placeholder="用户名"-->
    <!--                        :rules="[{ required: true, message: '请填写用户名' }]"-->
    <!--                      />-->
    <!--                      <van-field-->
    <!--                        left-icon="lock"-->
    <!--                        v-model="loginData.password"-->
    <!--                        type="password"-->
    <!--                        name="密码"-->
    <!--                        label=""-->
    <!--                        placeholder="密码"-->
    <!--                        :rules="[{ required: true, message: '请填写密码' }]"-->
    <!--                      />-->
    <!--                    </van-cell-group>-->
    <!--                    <div class="subBtn">-->
    <!--                      <van-button-->
    <!--                        round-->
    <!--                        block-->
    <!--                        type="primary"-->
    <!--                        :loading="loading"-->
    <!--                        native-type="submit"-->
    <!--                        class="submitBtn"-->
    <!--                      >-->
    <!--                        登 录-->
    <!--                      </van-button>-->
    <!--                    </div>-->
    <!--                  </van-form>-->
    <!--    </div>-->
    <div class="contentArea">
      <van-field
        readonly
        clickable
        name="picker"
        :value="testName"
        label="姓名"
        placeholder="点击选择用户"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="testData"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-button
        round
        block
        type="primary"
        class="testSubmitBtn"
        @click="testLoginFn"
      >
        登 录
      </van-button>
    </div>
    <p class="copyright">© 德迅科技</p>
  </div>
</template>

<script>
import {authorize, getConfigInfo} from '../service/getData'
import {setToken, setLoginInfo, setCheckLoginInfo, setAccountInfo, setConfig} from '../util/auth'
import {Toast} from 'vant'
import {userInfo} from '../assets/js/userInfo'

export default {
  data () {
    return {
      accountName: 'ics-zlt', // 企业账号信息
      loading: false,
      loginData: {
        nickname: '',
        companyAccount: '',
        companySecretKey: '',
        uniqueCode: '',
        password: ''
      },
      userInfo, // 本地存储的用户账户信息，用于模拟登录
      testData: [
        {name: '章山', code: '3500B914251F26831BE87759B122A48B'},
        {name: '李思', code: 'E80C5C920E5F516FBCF858147E35DAFC'},
        {name: '王武', code: '91A7D29084650CBA6BB219DA7E0FA728'},
        {name: '赵柳', code: '1185DFEE86E7B36D4A552E374872831B'},
        {name: '田启', code: '11E12283DCF690A780EABCE4A6973629'},
        {name: '吴霸', code: '8687090A83B63E98F1064DF4BB4CD16C'},
        {name: '孙咎', code: 'EE8DFB9AF5B02276E02688C8DCC85077'},
        {name: '周石', code: '3967A7954ACAEE2B299458B9DA2D608B'},
        {name: '冯诗亿', code: '73228559C7B6D059B3C22C9C88CEFC4B'},
        {name: '陈师儿', code: '9CC2C4BA027D721247E9A30CCA2C95B3'}
      ],
      showPicker: false,
      testName: '',
      code: ''
    }
  },
  methods: {
    // 原版登录
    // login () {
    //   const {companyAccount, companySecretKey, uniqueCode, password} = this.loginData
    //
    //   const user = this.userInfo.find(
    //     item => item.companyAccount === companyAccount &&
    //       item.companySecretKey === companySecretKey &&
    //       item.uniqueCode === uniqueCode &&
    //       item.password === password
    //   )
    //
    //   if (user) {
    //     // 本地校验成功，进行后端校验
    //     let params = {
    //       companyAccount: user.companyAccount,
    //       companySecretKey: user.companySecretKey,
    //       belongCompanyCode: user.belongCompanyCode,
    //       nickname: user.nickname,
    //       uniqueCode: user.uniqueCode,
    //       belongCompanyName: user.belongCompanyName
    //     }
    //
    //     loginSystem(params).then(res => {
    //       if (res.code === 0) {
    //         this.$router.push({name: 'chatDetail'})
    //         setToken(res.data.token)
    //         setLoginInfo(res.data)
    //         // 存储本地json信息
    //         let account = this.loginData
    //         account.belongCompanyCode = user.belongCompanyCode
    //         account.belongCompanyName = user.belongCompanyName
    //         localStorage.setItem('account', JSON.stringify(account))
    //       } else {
    //         Toast.fail(res.msg)
    //       }
    //     })
    //   } else {
    //     const companyExists = this.userInfo.some(item => item.companyAccount === companyAccount)
    //     if (!companyExists) {
    //       Toast.fail('未查询到对应的服务企业')
    //     } else if (this.userInfo.some(item => item.companyAccount === companyAccount && item.companySecretKey !== companySecretKey)) {
    //       Toast.fail('企业秘钥错误')
    //     } else {
    //       Toast.fail('账号或密码错误')
    //     }
    //   }
    // },

    // 本地开发登录
    testLoginFn () {
      if (this.code !== '' && this.code !== null && this.code !== undefined) {
        sessionStorage.setItem('dialogCode', this.code)
        // 验证登录
        this.checkLogin()
      } else {
        Toast.fail('请先选择用户')
      }
    },
    // 验证登录
    checkLogin () {
      let params = {
        code: this.code,
        account: this.accountName
      }
      authorize(params).then(res => {
        if (res.code === 0) {
          // 保存token
          setToken(res.data.token)
          // 保存登录信息
          setLoginInfo(res.data)
          // 保存登录验证信息
          setCheckLoginInfo(res.data)
          // 存储登录企业账号信息
          setAccountInfo(this.accountName)
          // 获取配置信息
          this.getConfigInfoFn()
        } else {
          this.$router.push({
            path: '/error',
            query: {
              msg: res.msg
            }
          })
        }
      })
    },
    // 获取配置信息
    getConfigInfoFn () {
      let params = {
        account: this.accountName
      }
      getConfigInfo(params).then(res => {
        if (res.code === 0) {
          // 存储配置信息
          setConfig(res.data)
          this.$router.push({
            path: '/'
          })
        } else {
          this.$router.push({
            path: '/error',
            query: {
              msg: res.msg
            }
          })
        }
      })
    },
    onConfirm (value) {
      this.testName = value.name
      this.code = value.code
      this.showPicker = false
    }
  },
  mounted () {
    let accountData = JSON.parse(localStorage.getItem('account'))
    if (accountData && accountData.nickname) {
      this.loginData.nickname = accountData.nickname
      this.loginData.password = accountData.password
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}

.debaoImg {
  width: 65px;
  height: 88px;
  vertical-align: middle;
}

.blue {
  color: #3756df;
}

.contentArea {
  width: 80%;
  border: 1px solid rgba(209, 209, 209, 1);
  padding: 10px;
  /* height: 51%; */
  /* border-radius: 24px; */
  /* background-color: rgba(255, 255, 255, 1); */
}

.van-cell {
  background-color: #fff;
}

.slogan {
  padding: 38px 20px 0 20px;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 700;
}

.subBtn {
  margin: 50px 20px 41px 20px;
}

.submitBtn {
  background-color: rgba(0, 122, 255, 1);
  border: 0.02667rem solid rgba(0, 122, 255, 1);
  border-radius: 8px;
}

.testSubmitBtn {
  background-color: rgba(0, 122, 255, 1);
  border: 0.02667rem solid rgba(0, 122, 255, 1);
  border-radius: 8px;
  margin-top: 20px;
}

.copyright {
  position: absolute;
  bottom: 67px;
  font-size: 14px;
  font-weight: 700;
}

/deep/ .van-icon__image {
  width: 25px;
  height: 25px;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue